import { render, staticRenderFns } from "./MyInvoice.vue?vue&type=template&id=284af072&scoped=true"
import script from "./MyInvoice.vue?vue&type=script&lang=js"
export * from "./MyInvoice.vue?vue&type=script&lang=js"
import style0 from "./MyInvoice.vue?vue&type=style&index=0&id=284af072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284af072",
  null
  
)

export default component.exports